import { zfUtils } from "./zf_utils";
export class zfclt {
    static init() {
        $(".zfcnlt-newsletter-teaser form")
            .off("submit.zfclt")
            .on("submit.zfclt", function (event) {
            event.preventDefault();
            location.href =
                $(this).attr("action") + "?email=" + $(this).find("input").val();
        });
    }
}
zfUtils.onReady(zfclt.init);
